#import './landing-page-stub-fragment.graphql'
#import "../../../core/subdomains/graphql/fragments/subdomain-fragment.graphql"

fragment LandingPageFullFragment on Page {
    ...LandingPageStubFragment
    urlSlug
    iframeEmbedCode
    subdomainRecord {
        ...SubdomainFragment
    }
    editableVersion {
        id
        beeBodyJson
    }
    publishedVersion {
        id
        beeBodyJson
        htmlMaterialized
        publisherUser {
            id
            name
        }
    }
}
